
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			getArticleStatus:`get /apis/baohuo-yuanchuang/oneClick/article/status`,
			getMiguArticleStatus:`get /apis/baohuo-yuanchuang/migu/oneClick/article/status`,
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"audioCreating"
			})
		}